import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateWordsToAvoid($customerId: ID!, $wordsToAvoid: [String!]) {
    updateCustomerSettings(customerId: $customerId, wordsToAvoid: $wordsToAvoid) {
      wordsToAvoid
    }
  }
`;

export const updateWordsToAvoid = ({ customerId, wordsToAvoid }) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, wordsToAvoid },
  }).then(({ data }) => {
    const result = getSingleProp(data);
    return result?.wordsToAvoid || [];
  });
